<template>
    <b-container fluid class="px-md-5">
        <h4 class="mt-4 p-2 text-center text-primary text-uppercase">Aprobadas</h4>
        <b-row class="justify-content-center">
            <b-col cols="12" class="mt-4 mb-2">
                <b-form-group class="mb-0">
                    <b-input-group size="sm">
                        <b-form-input id="search" v-model="search" type="search" placeholder="Buscar" class="pad-3-15 btlr-30 bblr-30"></b-form-input>

                        <b-input-group-append>
                            <b-button variant="default" :disabled="!search" @click="search = ''" class="m-0 btlr-0 bblr-0">
                                <i class="material-icons mdi mdi-close"></i>
                            </b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12" class="px-0">
                <b-table
                    :items="items"
                    :fields="fields"
                    responsive="sm"
                    class="my-2 border-bottom"
                    stacked="sm"
                    hover
                    small
                    show-empty
                    no-border-collapse
                    table-variant="light"
                    details-td-class="px-0"
                    empty-filtered-text="No hay transacciones que coincidan con la búsqueda"
                    empty-text="No hay transacciones para mostrar"
                    :current-page="currentPage"
                    :per-page="perPage"
                    :filter="search"
                    :busy="isBusy"
                    @filtered="onFiltered">
                    <template #cell(actions)="row">
                        <b-button variant="primary" size="sm" @click="getInfo(row.item.id)" v-b-modal.edit v-if="user.role === 'Administrator'">
                            <i class="material-icons">edit</i>
                        </b-button>
                        <b-button variant="success" size="sm" @click="id = row.item.id" :disabled="row.item.office" v-b-modal.complete>
                            <i class="material-icons">verified</i>
                        </b-button>
                        <b-button variant="warning" size="sm" @click="getRestore(row.item.id)" v-if="user.role === 'Administrator'">
                            <i class="material-icons">restart_alt</i>
                        </b-button>
                        <b-button variant="danger" size="sm" @click="getReject(row.item.id)" v-if="user.role === 'Administrator'">
                            <i class="material-icons">cancel</i>
                        </b-button>
                        <b-button class="text-white" variant="info" size="sm" :to="'/admin/request/'+row.item.id+'/details'">
                            <i class="material-icons">info</i>
                        </b-button>
                    </template>

                    <template #table-busy>
                        <div class="text-center text-danger my-4">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Actualizando...</strong>
                        </div>
                    </template>
                </b-table>

                <!-- Modal Edit -->
                <b-modal
                    id="edit"
                    centered
                    no-fade
                    header-class="text-center"
                    header-bg-variant="primary"
                    header-text-variant="light"
                    header-close-variant="light"
                    footer-class="border-0"
                    hide-footer
                    body-class="text-center px-4 my-4"
                    :title="'ID: '+id"
                    tabindex="-1"
                    role="dialog"
                    size="lg"
                    aria-hidden="true"
                    v-if="user.role === 'Administrator'">
                    <b-form id="formEdit" @submit.stop.prevent="getEdit()">
                        <b-row class="justify-content-center">
                            <b-col cols="12" md="10" align-self="start">
                                <b-form-group :label="labels.name+':'">
                                    <b-form-input
                                        name="name"
                                        v-model="form.name"
                                        type="text"
                                        class="text-center"
                                        v-validate="'required:true|alpha_spaces|min:3|max:20'"
                                        :state="validateState('name')"
                                        :data-vv-as="(labels.name).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="name-live-feedback"
                                    ></b-form-input>
                                    <b-form-invalid-feedback id="name-live-feedback">{{
                                            veeErrors.first('name')
                                        }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.lname+':'">
                                    <b-form-input
                                        name="lname"
                                        v-model="form.lname"
                                        type="text"
                                        class="text-center"
                                        v-validate="'required:true|alpha_spaces|min:3|max:20'"
                                        :state="validateState('lname')"
                                        :data-vv-as="(labels.lname).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="lname-live-feedback"
                                    ></b-form-input>
                                    <b-form-invalid-feedback id="lname-live-feedback">{{
                                            veeErrors.first('lname')
                                        }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.mname+':'">
                                    <b-form-input
                                        name="mname"
                                        v-model="form.mname"
                                        type="text"
                                        class="text-center"
                                        v-validate="'alpha_spaces|max:19'"
                                        :state="validateState('mname')"
                                        :data-vv-as="(labels.mname).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="mname-live-feedback"
                                    ></b-form-input>
                                    <b-form-invalid-feedback id="mname-live-feedback">{{
                                            veeErrors.first('mname')
                                        }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.td+':'">
                                    <b-form-select
                                        name="td"
                                        :options="td"
                                        :value="form.td"
                                        v-model="form.td"
                                        class="form-control select-center"
                                        v-validate="'required:true'"
                                        :state="validateState('td')"
                                        :data-vv-as="(labels.td).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="td-live-feedback"
                                        value-field="code"
                                        text-field="name"
                                    ></b-form-select>
                                    <b-form-invalid-feedback id="td-live-feedback">{{
                                            veeErrors.first('td')
                                        }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.nd+':'">
                                    <b-form-input
                                        name="nd"
                                        v-model="form.nd"
                                        type="text"
                                        class="text-center"
                                        v-validate="'required:true'"
                                        :state="validateState('nd')"
                                        :data-vv-as="(labels.nd).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="nd-live-feedback"
                                    ></b-form-input>
                                    <b-form-invalid-feedback id="nd-live-feedback">{{
                                            veeErrors.first('nd')
                                        }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.issuedBy+':'">
                                    <b-form-select
                                        name="sender_issuedBy"
                                        :options="countries"
                                        :value="form.issuedBy"
                                        v-model="form.issuedBy"
                                        v-validate=""
                                        :state="validateState('issuedBy')"
                                        :data-vv-as="(labels.issuedBy).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="issuedBy-live-feedback"
                                        class="form-control"
                                        value-field="iso2"
                                        text-field="name"
                                    ></b-form-select>
                                    <b-form-invalid-feedback id="issuedBy-live-feedback">{{ veeErrors.first('issuedBy') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.email+':'">
                                    <b-form-input
                                        name="email"
                                        v-model="form.email"
                                        type="email"
                                        class="text-center"
                                        v-validate="'email'"
                                        :state="validateState('email')"
                                        :data-vv-as="(labels.email).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="email-live-feedback"
                                    ></b-form-input>
                                    <b-form-invalid-feedback id="email-live-feedback">{{
                                            veeErrors.first('email')
                                        }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.mobile+':'">
                                    <b-form-input
                                        name="mobile"
                                        v-model="form.mobile"
                                        type="tel"
                                        inputmode="tel"
                                        class="text-center"
                                        v-validate=""
                                        :state="validateState('mobile')"
                                        :data-vv-as="(labels.mobile).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="mobile-live-feedback"
                                    ></b-form-input>
                                    <b-form-invalid-feedback id="mobile-live-feedback">{{
                                            veeErrors.first('mobile')
                                        }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="10" align-self="start" class="my-4">
                                <b-button type="submit" variant="default" size="lg" pill class="shadow align-middle px-5"
                                          form="formEdit" :disabled="loading">
                                    <b-spinner small type="grow" v-if="loading"></b-spinner>
                                    <b-icon icon="upload" aria-hidden="true" class="align-middle" v-else></b-icon>
                                    &nbsp;&nbsp;<span>{{ loading ? 'Actualizando...' : 'Actualizar' }}</span>
                                </b-button>
                            </b-col>
                        </b-row>
                    </b-form>
                </b-modal>

                <!-- Modal Complete -->
                <b-modal
                    id="complete"
                    centered
                    no-fade
                    header-class="text-center"
                    header-bg-variant="primary"
                    header-text-variant="light"
                    header-close-variant="light"
                    footer-class="border-0"
                    hide-footer
                    body-class="text-center px-4 my-4"
                    :title="'ID: '+id"
                    tabindex="-1"
                    role="dialog"
                    size="lg"
                    aria-hidden="true">
                    <b-form id="formImage" @submit.stop.prevent="saveImage()">
                        <b-row class="justify-content-center">
                            <b-col cols="12" md="10" align-self="start">
                                <b-form-group :label="labels.voucher+':'">
                                    <b-form-file
                                        name="voucher"
                                        v-model="voucher"
                                        v-validate="'required:true|image|size:5120'"
                                        :data-vv-as="(labels.voucher).toLowerCase()"
                                        aria-describedby="voucher-live-feedback"
                                        :state="voucher ? Boolean(voucher) : voucher || validateState('voucher')"
                                        placeholder="Seleccione un archivo ..."
                                        drop-placeholder="Suelta el archivo aquí ..."
                                        accept="image/*"
                                        browse-text="Buscar"
                                        size="lg"
                                    ></b-form-file>
                                    <b-form-invalid-feedback id="voucher-live-feedback">{{ veeErrors.first('voucher') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="9" md="7" lg="5" align-self="start" v-if="imageData">
                                <img :src="imageData" width="100%" alt="voucher" style="border: 1px solid #eee; border-radius: 4px;"/>
                            </b-col>
                            <b-col cols="12" md="10" align-self="start" class="my-4">
                                <b-button type="submit" variant="default" size="lg" pill class="shadow align-middle px-5"
                                          form="formImage" :disabled="loading">
                                    <b-spinner small type="grow" v-if="loading"></b-spinner>
                                    <b-icon icon="upload" aria-hidden="true" class="align-middle" v-else></b-icon>
                                    &nbsp;&nbsp;<span>{{ loading ? 'Confirmando...' : 'Confirmar' }}</span>
                                </b-button>
                            </b-col>
                        </b-row>
                    </b-form>
                </b-modal>
            </b-col>
            <b-col sm="5" md="6">
                <b-form-group
                    label="Mostrar:"
                    label-for="per-page-select"
                    label-cols-sm="4"
                    label-cols-md="6"
                    label-cols-lg="9"
                    label-align-sm="right"
                    label-size="sm"
                    class="mt-2 mb-8">
                    <b-form-select
                        id="per-page-select"
                        v-model="perPage"
                        :options="pageOptions"
                        size="sm"
                    ></b-form-select>
                </b-form-group>
            </b-col>
            <b-col sm="7" md="6">
                <b-pagination
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    align="fill"
                    size="sm"
                    class="mt-2 mb-8"
                ></b-pagination>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import axios from "axios";

export default {
    name: "Approved",
    props: [ 'user' ],
    data: () => ({
        id: 0,
        loading: false,
        isBusy: true,
        search: '',
        fields: [
            { key: 'id', label: 'ID', sortable: false, thClass: 'text-sm-right', tdClass: 'text-sm-right' },
            { key: 'int_id', label: 'Código', sortable: false, thClass: 'text-sm-right', tdClass: 'text-sm-right' },
            { key: 'customer', label: 'Corresponsal', sortable: false },
            { key: 'fee_text', label: 'Comisión', sortable: false, thClass: 'text-sm-right', tdClass: 'text-sm-right' },
            { key: 'amount_send_text', label: 'Valor Origen', sortable: false, thClass: 'text-sm-right', tdClass: 'text-sm-right' },
            { key: 'currency_send', label: 'Moneda Origen', sortable: false },
            { key: 'fx_rate', label: 'Conversión', sortable: false, thClass: 'text-sm-right', tdClass: 'text-sm-right' },
            { key: 'amount_receiver_text', label: 'Valor Destino', sortable: false, thClass: 'text-sm-right', tdClass: 'text-sm-right' },
            { key: 'currency_receiver', label: 'Moneda Destino', sortable: false },
            { key: 'date', label: 'Fecha', sortable: false },
            { key: 'actions', label: 'Acción', sortable: false, thClass: 'text-sm-center', tdClass: 'text-sm-center' }
        ],
        items: [],
        totalRows: 1,
        currentPage: 1,
        perPage: 25,
        pageOptions: [25, 50, 100, { value: -1, text: "Todos" }],
        labels: {
            voucher: 'Comprobante de Pago',
            name: 'Nombres',
            lname: 'Primer Apellido',
            mname: 'Segundo Apellido',
            td: 'Tipo de Documento',
            nd: 'Número de Documento',
            issuedBy: 'País de emisión',
            email: 'Correo Electrónico',
            mobile: 'Teléfono'
        },
        form: {
            name: null,
            lname: null,
            mname: null,
            td: null,
            nd: null,
            issuedBy: null,
            email: null,
            mobile: null
        },
        countries: [],
        td: [
            { code: 'RUT', name: 'RUT' },
            { code: 'DNI', name: 'Documento Nacional de Identidad' },
            { code: 'CI', name: 'Cédula de Identidad' },
            { code: 'CE', name: 'Cédula de Extranjeria' },
            { code: 'PS', name: 'Pasaporte' }
        ],
        voucher: null,
        imageData: null
    }),
    mounted() {
        this.$emit('loader');
        this.$emit('section', 'approvedpage');
        this.totalRows = this.items.length;
        this.getIni();
    },
    watch: {
        'form.nd'() {
            this.form.nd = (this.form.nd).toUpperCase();
        },
        voucher() {
            if (this.voucher) {
                this.getVoucher();
            }
        }
    },
    methods: {
        getIni() {
            axios.get('/api/paymaster/approved').then((res) => {
                if (res.data.status === 'success') {
                    this.items = res.data.items;
                    this.totalRows = this.items.length;
                    this.countries = res.data.countries;
                }
            }).catch(err => {
                this.$root.$bvToast.toast(err.response.data.errors, {
                    title: 'Notificación',
                    headerClass: 'd-none',
                    variant: 'error',
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 5000,
                    solid: true,
                    appendToast: true
                });
            }).then(() => {
                this.isBusy = false;
            });
        },
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        validateState(ref) {
            if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },
        resetValidationState() {
            this.isValid = undefined
        },
        getInfo(id) {
            this.id = id;
            const items = this.items;

            for (let i = 0; i < items.length; i++) {
                if (items[i].id === id) {
                    let lname = (items[i].receiver.lname).split(', ', 2);
                    this.form = {
                        name: items[i].receiver.name,
                        lname: lname[0],
                        mname: lname[1] ? lname[1] : '',
                        td: items[i].receiver.td,
                        nd: items[i].receiver.nd,
                        issuedBy: items[i].receiver.issuedBy,
                        email: items[i].receiver.email,
                        mobile: items[i].receiver.mobile
                    };
                }
            }
        },
        clearData() {
            this.id = 0;
            this.form = {
                name: null,
                lname: null,
                mname: null,
                td: null,
                nd: null,
                issuedBy: null,
                email: null,
                mobile: null
            };
        },
        getEdit(){
            this.$validator.validateAll().then(result => {
                if (!result) { return; }
                this.loading = true;
                let formData = new FormData();
                formData.append('id', this.id);
                formData.append('name', this.form.name);
                formData.append('lname', this.form.lname);
                formData.append('mname', this.form.mname);
                formData.append('td', this.form.td);
                formData.append('nd', this.form.nd);
                formData.append('issuedBy', this.form.issuedBy);
                formData.append('email', this.form.email);
                formData.append('mobile', this.form.mobile);
                axios.post('/api/paymaster/edit', formData, {
                    headers: {'Content-Type': 'multipart/form-data'}
                }).then((res) => {
                    this.$root.$bvToast.toast(res.data.msg, {
                        title: 'Notificación',
                        headerClass: 'd-none',
                        variant: res.data.status,
                        toaster: 'b-toaster-top-right',
                        autoHideDelay: 5000,
                        solid: true,
                        appendToast: true
                    });
                    if (res.data.status === 'success') {
                        this.getIni();
                        this.clearData();
                        this.$validator.reset();
                        this.$bvModal.hide('edit');
                    }
                }).catch(err => {
                    this.$root.$bvToast.toast(err.response.data.errors, {
                        title: 'Notificación',
                        headerClass: 'd-none',
                        variant: 'error',
                        toaster: 'b-toaster-top-right',
                        autoHideDelay: 5000,
                        solid: true,
                        appendToast: true
                    });
                }).then(() => {
                    this.loading = false;
                });
            });
        },
        getVoucher() {
            const input = this.voucher;

            if (input) {
                const reader = new FileReader;
                reader.onload = e => {
                    this.imageData = e.target.result;
                };
                reader.readAsDataURL(input);
            }
        },
        clearVoucher() {
            this.id = 0;
            this.voucher = null;
            this.imageData = null;
        },
        saveImage() {
            this.$validator.validateAll().then(result => {
                if (!result) { return; }
                this.loading = true;
                let formData = new FormData();
                formData.append('id', this.id);
                formData.append('voucher', this.voucher);
                axios.post('/api/paymaster/complete', formData, {
                    headers: {'Content-Type': 'multipart/form-data'}
                }).then((res) => {
                    this.$root.$bvToast.toast(res.data.msg, {
                        title: 'Notificación',
                        headerClass: 'd-none',
                        variant: res.data.status,
                        toaster: 'b-toaster-top-right',
                        autoHideDelay: 5000,
                        solid: true,
                        appendToast: true
                    });
                    if (res.data.status === 'success') {
                        this.getIni();
                        this.clearVoucher();
                        this.$validator.reset();
                        this.$bvModal.hide('complete');
                    }
                }).catch(err => {
                    this.$root.$bvToast.toast(err.response.data.errors, {
                        title: 'Notificación',
                        headerClass: 'd-none',
                        variant: 'error',
                        toaster: 'b-toaster-top-right',
                        autoHideDelay: 5000,
                        solid: true,
                        appendToast: true
                    });
                }).then(() => {
                    this.loading = false;
                });
            });
        },
        getRestore(id) {
            this.$swal({
                title: '¿Estas seguro de restaurar este pago?',
                text: 'ID: ' + id,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Si, restaurar',
                confirmButtonColor: '#28a745',
                cancelButtonText: 'En otro momento',
                cancelButtonColor: '#dc3545',
                allowOutsideClick: false,
                allowEscapeKey: false,
                reverseButtons: true
            }).then((result) => {
                if (result.value) {
                    this.id = id;

                    let formData = new FormData();
                    formData.append('id', id);

                    axios.post('/api/paymaster/restore', formData).then(res => {
                        if (res.data.status === 'success') {
                            const items = this.items;

                            for (let i = 0; i < items.length; i++) {
                                if (items[i].id === id) {
                                    items.splice( i, 1 );
                                    this.totalRows = this.items.length;
                                }
                            }
                        }
                        this.$root.$bvToast.toast(res.data.msg, {
                            title: 'Notificación',
                            headerClass: 'd-none',
                            variant: res.data.status,
                            toaster: 'b-toaster-top-right',
                            autoHideDelay: 5000,
                            solid: true,
                            appendToast: true
                        });
                    }).catch(err => {
                        this.$root.$bvToast.toast(err.response.data.errors, {
                            title: 'Notificación',
                            headerClass: 'd-none',
                            variant: 'error',
                            toaster: 'b-toaster-top-right',
                            autoHideDelay: 5000,
                            solid: true,
                            appendToast: true
                        });
                    });
                }
            });
        },
        getReject(id) {
            this.$swal({
                title: '¿Estas seguro de rechazar este pago?',
                text: 'ID: ' + id,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Si, rechazar',
                confirmButtonColor: '#28a745',
                cancelButtonText: 'En otro momento',
                cancelButtonColor: '#dc3545',
                allowOutsideClick: false,
                allowEscapeKey: false,
                reverseButtons: true
            }).then((result) => {
                if (result.value) {
                    this.id = id;

                    let formData = new FormData();
                    formData.append('id', id);

                    axios.post('/api/paymaster/reject', formData).then(res => {
                        if (res.data.status === 'success') {
                            const items = this.items;

                            for (let i = 0; i < items.length; i++) {
                                if (items[i].id === id) {
                                    items.splice( i, 1 );
                                    this.totalRows = this.items.length;
                                }
                            }
                        }
                        this.$root.$bvToast.toast(res.data.msg, {
                            title: 'Notificación',
                            headerClass: 'd-none',
                            variant: res.data.status,
                            toaster: 'b-toaster-top-right',
                            autoHideDelay: 5000,
                            solid: true,
                            appendToast: true
                        });
                    }).catch(err => {
                        this.$root.$bvToast.toast(err.response.data.errors, {
                            title: 'Notificación',
                            headerClass: 'd-none',
                            variant: 'error',
                            toaster: 'b-toaster-top-right',
                            autoHideDelay: 5000,
                            solid: true,
                            appendToast: true
                        });
                    });
                }
            });
        }
    }
}
</script>

<style scoped>

</style>
